import {
  PopoverContent as AdsTooltipContent,
  PopoverTrigger,
  Button as AdsButton,
} from '@accolade/design-system-react';
import styled from '@emotion/styled';
import { colors } from 'src/js/nextgen/plushcare-components';
import { InfoIcon } from '@accolade/design-system-react-icons';
import { breakpoints } from '../helpers/plushcare-style-defaults';

const hideFocusBorder = `
:focus {
  outline: none;
  border-color: rgba(0,0,0,0);
  box-shadow: none !important;
}
`;

export const TooltipHeader = styled.h1`
    font-size: 14px;
    font-weight: 600;
    color: ${colors.support};
`;

export const TooltipBody = styled.div`
    color: ${colors.support};
    line-height: 16px;
    font-size: 14px;
`;

export const CloseButton = styled.button`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  background: none;
  border: none;
  color: ${colors.royalBlue};
  padding: 0px;
  margin: 10px 16px 0 0;

  &:hover {
    color: ${colors.black};
  }
  ${hideFocusBorder}
`;

export const TooltipIcon = styled(InfoIcon)`
  transform: scale(1.5);
`;

export const ActionButton = styled.a`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  background: none;
  border: none;
  color: ${colors.royalBlue};
  padding: 0px;
  margin-right: 16px;
  text-decoration: none;
  ${hideFocusBorder}
`;
export const TriggerText = styled.span`
  margin-right: 10px;
`;

export const TooltipContent = styled(AdsTooltipContent)`
  box-shadow: 0px 4px 4px rgb(0 0 0 / 15%);
  border-radius: 8px !important;
  padding: 12px !important;
  font-size: 14px;
  line-height: 16px;
  width: 265px;

  @media (max-width: ${breakpoints.mobile}) {
    width: 235px;
  }
  ${hideFocusBorder}

  .tooltip-list {
    margin-top: 8px;
    margin-bottom: 0;
    padding-left: 18px;
  }
`;

export const Trigger = styled(PopoverTrigger)`
  ${hideFocusBorder}
`;

export const Button = styled(AdsButton)`
  border-radius: 0px !important;
  padding: 0px !important;
  overflow: visible !important;
  color: ${colors.support} !important;
  ${hideFocusBorder}
`;
